import React, { useContext } from "react";
import "./styles";
import { ImageUploadLogoContainer, ModalCroppingContainer } from "./styles";
import { ImageUploadWithCrop } from "../ImageUploadWithCrop";
import { Toggle } from "../../Toggle/Toggle";
import { isDevOrLocal } from "../../../hooks/useApi";
import { ReactComponent as Plus } from "../../../assets/newImages/icons/plus.svg";
import { ReactComponent as Loading } from "../../../assets/newImages/icons/rounded.svg";
import ModalRelativo from "../../ModalRelativo/ModalRelativo";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { ConfiguracoesContext } from "../../../contexts/Configuracoes/ConfiguracoesContext";
import FotoUsuario from "../../Uteis/FotoUsuario";
import { text } from "stream/consumers";
import { LogoContainer } from "../../Mockups/MockupCatalogo/styles";

interface ImageUploadLogoProps {
  value: string;
  onChange: (base64: string, imagem: string, size: number) => void;
  onLoading?: (loading: boolean) => void;
  configIn: "empresa" | "configuracoes";
}

const ImageUploadLogo: React.FC<ImageUploadLogoProps> = ({
  onChange,
  value,
  configIn,
}) => {
  const { theme } = useTheme();

  const [loading, setLoading] = React.useState(false);
  // Toggle de remover fundo: aplicado no próximo upload; só vale em dev.
  const [removerFundo, setRemoverFundo] = React.useState(false);
  const {
    configuracoes,
    processarLogo,
    loading: loadingConfigs,
  } = useContext(ConfiguracoesContext);

  return (
    <ImageUploadLogoContainer theme={theme}>
      <ImageUploadWithCrop
        onLoading={(loading) => {
          setLoading(loading);
        }}
        className={`logo-input-container-empresa`}
        acceptFormats={".png, .jpeg, .jpg, .webp, .heic, .heif"}
        value={value}
        aspectRatio={1 / 1}
        onChange={(base64, imagem, size) => processarLogo(base64, removerFundo)}
        circularCrop={true}
        resize={{ width: 500, height: 500 }}
        minWidth={500}
        minHeight={500}
        errorMargin={50}
        onOpenCrop={(cropping, cancelar, salvar) => (
          <ModalRelativo
            removeConfirm={true}
            isOpen={true}
            setIsOpen={() => {}}
            normalModal={configIn === "configuracoes" ? true : false}
            titulo={""}
            subtitulo={""}
            width="auto"
            background="none"
            center={true}
            right="40%"
          >
            <ModalCroppingContainer theme={theme}>
              <div className="titulo fonteTexto">Editar imagem</div>
              {cropping}
              {isDevOrLocal && (
                <div className="remover-fundo fonteRotulos">
                  <span>Remover fundo da logo</span>
                  <Toggle value={removerFundo} onChange={setRemoverFundo} />
                </div>
              )}
              <div className="botoes fonteTexto">
                {cancelar}
                {salvar}
              </div>
            </ModalCroppingContainer>
          </ModalRelativo>
        )}
      >
        <div className="logo-wrapper">
          <div className="logo">
            <div className="texto fonteTexto">Logotipo</div>
            {loading || loadingConfigs ? (
              <div className="loading">
                <Loading />
              </div>
            ) : (
              <div className="plus">
                {value ? (
                  // <FotoUsuario size={5} ativo={false}>
                  //   <img src={value} alt="Logotipo" />
                  // </FotoUsuario>
                  <LogoContainer theme={theme} className="logo">
                    {configuracoes.dados_empresa.informacoes_gerais.logotipo && (
                      <img
                        src={
                          configuracoes.dados_empresa.informacoes_gerais.logotipo["base64"]
                            ? configuracoes.dados_empresa.informacoes_gerais.logotipo[
                                "base64"
                              ]
                            : configuracoes.dados_empresa.informacoes_gerais.logotipo
                        }
                        alt="imagem do logotipo"
                      />
                    )}
                  </LogoContainer>
                ) : (
                  <Plus />
                )}
              </div>
            )}
          </div>
        </div>
      </ImageUploadWithCrop>
    </ImageUploadLogoContainer>
  );
};

export default ImageUploadLogo;
